<div class="row gap-2 mt-3 mb-5 p-3">
  <span class="m-0 mb-3">Selecione uma das opções abaixo:</span>
  <!-- <app-consulting-project></app-consulting-project>
  <app-follow-up-service></app-follow-up-service> -->
  <app-financial-consultancy class="col"></app-financial-consultancy>
  <app-advisor class="col"></app-advisor>
</div>
